import React from "react";

export const SvgThreejs = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="0.9"
      version="1.1"
      viewBox="0 0 32 32"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-1 0)"
    >
      <polygon points="7,6 30,12 13,28 " />
      <polygon points="13,7 9,11 25,16 24,11 12,22 17,24 " />
      <polygon points="10,17 21,20 18,9 " />
    </svg>
  );
};

export const SvgBlender = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      version="1.1"
      viewBox="0 0 32 32"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(0 4)"
    >
      <path d="M 15.984375 14.007812 C 16.039062 12.992188 16.527344 12.097656 17.257812 11.460938 C 17.980469 10.835938 18.949219 10.457031 20.007812 10.457031 C 21.066406 10.457031 22.035156 10.835938 22.753906 11.460938 C 23.488281 12.097656 23.976562 12.992188 24.03125 14.007812 C 24.085938 15.054688 23.679688 16.027344 22.957031 16.746094 C 22.222656 17.476562 21.175781 17.9375 20.007812 17.9375 C 18.839844 17.9375 17.792969 17.476562 17.058594 16.746094 C 16.335938 16.027344 15.925781 15.054688 15.984375 14.007812 Z M 15.984375 14.007812 " />
      <path d="M 9.574219 16.066406 C 9.582031 16.464844 9.707031 17.238281 9.890625 17.84375 C 10.28125 19.121094 10.945312 20.304688 11.871094 21.347656 C 12.816406 22.417969 13.984375 23.28125 15.332031 23.890625 C 16.746094 24.53125 18.285156 24.859375 19.875 24.855469 C 21.46875 24.855469 23.003906 24.519531 24.417969 23.875 C 25.765625 23.257812 26.929688 22.394531 27.878906 21.320312 C 28.800781 20.273438 29.464844 19.089844 29.855469 17.808594 C 30.054688 17.164062 30.175781 16.507812 30.226562 15.847656 C 30.277344 15.203125 30.253906 14.550781 30.164062 13.902344 C 29.988281 12.640625 29.5625 11.453125 28.90625 10.371094 C 28.300781 9.378906 27.527344 8.507812 26.601562 7.773438 L 26.605469 7.773438 L 17.292969 0.457031 C 17.285156 0.449219 17.277344 0.441406 17.269531 0.4375 C 16.65625 -0.0429688 15.632812 -0.0429688 14.960938 0.4375 C 14.277344 0.925781 14.203125 1.730469 14.804688 2.238281 L 18.6875 5.472656 L 6.851562 5.484375 C 6.84375 5.484375 6.839844 5.484375 6.832031 5.484375 C 5.855469 5.484375 4.914062 6.144531 4.730469 6.972656 C 4.539062 7.820312 5.203125 8.519531 6.21875 8.523438 L 6.21875 8.527344 L 12.21875 8.515625 L 1.511719 16.925781 C 1.496094 16.9375 1.484375 16.945312 1.46875 16.957031 C 0.460938 17.75 0.132812 19.066406 0.769531 19.898438 C 1.417969 20.746094 2.789062 20.746094 3.808594 19.902344 L 9.652344 15.007812 C 9.652344 15.007812 9.566406 15.671875 9.574219 16.066406 Z M 24.589844 18.277344 C 23.386719 19.535156 21.699219 20.246094 19.875 20.25 C 18.050781 20.253906 16.363281 19.546875 15.160156 18.292969 C 14.570312 17.683594 14.140625 16.980469 13.871094 16.230469 C 13.613281 15.496094 13.511719 14.714844 13.578125 13.929688 C 13.640625 13.160156 13.863281 12.425781 14.222656 11.761719 C 14.574219 11.105469 15.058594 10.515625 15.65625 10.015625 C 16.824219 9.039062 18.316406 8.511719 19.875 8.511719 C 21.433594 8.507812 22.921875 9.03125 24.09375 10.003906 C 24.691406 10.5 25.171875 11.089844 25.523438 11.742188 C 25.882812 12.40625 26.105469 13.136719 26.171875 13.910156 C 26.238281 14.695312 26.136719 15.476562 25.875 16.210938 C 25.609375 16.960938 25.175781 17.664062 24.589844 18.277344 Z M 24.589844 18.277344 " />
    </svg>
  );
};

export const SvgSubstance = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      version="1.1"
      viewBox="0 0 32 32"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points="4,17 4,23 16,30 28,23 28,17 11,11 15,8 22,12 22,13 28,15 28,9 16,2 4,9 4,15 21,21 16,24 10,20 10,19 " />
    </svg>
  );
};

export const SvgArduino = () => {
  return (
    <svg
      stroke="currentColor"
      version="1.1"
      viewBox="0 0 32 32"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(0 12)"
    >
      <path
        fill="none"
        strokeWidth="50"
        d="M 174.012097 30.015625 C 93.629032 30.015625 28.487903 92.703125 28.487903 170 C 28.487903 247.296875 93.629032 309.984375 174.012097 309.984375 C 363.991935 319.989583 344.032258 30.015625 543.991935 30.015625 C 624.375 30.015625 689.516129 92.703125 689.516129 170 C 689.516129 247.296875 624.375 309.984375 543.991935 309.984375 C 354.012097 319.989583 373.971774 30.015625 174.012097 30.015625 "
        transform="matrix(0.0430556,0,0,0.0441176,0,0)"
      />
      <path
        fill="currentColor"
        strokeWidth="18"
        d="M 528.024194 194.708333 L 528.024194 161.859375 L 495.544355 161.859375 L 495.544355 148.223958 L 528.024194 148.223958 L 528.024194 115.640625 L 541.905242 115.640625 L 541.905242 148.223958 L 574.475806 148.223958 L 574.475806 161.859375 L 541.905242 161.859375 L 541.905242 194.708333 Z M 528.024194 194.708333 "
        transform="matrix(0.0430556,0,0,0.0441176,0,0.441176)"
      />
      <path
        fill="currentColor"
        strokeWidth="18"
        d="M 321.412533 266.264121 L 321.412533 248.947614 L 374.644304 248.947614 L 374.644304 266.264121 Z M 321.412533 266.264121 "
        transform="matrix(0.0673646,0,0,0.0281974,-15.749486,0.0232824)"
      />
    </svg>
  );
};

export const SkillHexagon = (props) => {
  let align = 15;
  if (props.align === "R") {
    align = -45;
  }

  return (
    <div className="skillHexagon" style={{ marginLeft: align + "px" }}>
      <div className="hexagonContener">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
        >
          <polygon
            className="hexagonIco"
            points="51,3 71,15 92,26 92,50 92,74 71,85 51,97 31,85 10,74 10,50 10,26 31,15 "
          />
        </svg>
      </div>
      <div className="skillIcon">{props.icon}</div>
    </div>
  );
};
